export enum PhoneCountryCodesEnum {
  AR = '+54',
  UY = '+598',
  BR = '+55',
  PY = '+595',
}
